/**
 * 新建活动向导：首步 POST /activities 成功后把 id 写入 sessionStorage，
 * 供 /conference/events/create/* 无 :id 路由读取。
 */
export const PENDING_CREATE_ACTIVITY_ID_KEY = 'vue_photos_pending_create_activity_id'

/** 其它向导页在缺少活动 id 时的统一提示（文案见 i18n conference.eventCreateGate.needEventFirst） */
export const MSG_NEED_ACTIVITY_FIRST_KEY = 'conference.eventCreateGate.needEventFirst'

export function readPendingCreateActivityId () {
  try {
    const raw = sessionStorage.getItem(PENDING_CREATE_ACTIVITY_ID_KEY)
    const n = Number(raw)
    return Number.isInteger(n) && n > 0 ? n : null
  } catch {
    return null
  }
}

export function writePendingCreateActivityId (id) {
  const n = Number(id)
  if (!Number.isInteger(n) || n <= 0) return
  try {
    sessionStorage.setItem(PENDING_CREATE_ACTIVITY_ID_KEY, String(n))
  } catch {
    /* ignore */
  }
}

export function clearPendingCreateActivityId () {
  try {
    sessionStorage.removeItem(PENDING_CREATE_ACTIVITY_ID_KEY)
  } catch {
    /* ignore */
  }
}
